import { defineMessages } from "react-intl";

export const transtionsAttributesPageFieldsMessages = defineMessages({
  values: {
    id: "JE0TAx",
    defaultMessage: "Values",
    description: "section name",
  },

  valueNumber: {
    id: "UvD+xp",
    defaultMessage: "Value {number}",
    description: "attribute values",
  },
});
